import { FC } from "react";
import styles from "./Legend.module.sass";
import cn from "classnames";
import { ReactComponent as Clock } from "images/Clock.svg";
import { useAppSelector } from "toolkit/hooks";

export const Legend: FC = () => {
	const { tableMode, batchesMode } = useAppSelector((state) => state.stepSix);

	return (
		<div data-comment-false={true} className={styles.legend}>
			<span className={styles["legend-title"]}>Легенда:</span>
			<div className={styles["legend-item-wrp"]}>
				<div className={styles["legend-item"]}>
					<div
						className={cn(
							styles["legend-item-sign"],
							tableMode ? styles["legend-item-sign-variant-table"] : styles["legend-item-sign-variant-group"],
							styles["legend-item-sign-done"],
						)}></div>
					<span className={styles["legend-item-txt"]}>Объект получил категорию</span>
				</div>
			</div>
			<div className={styles["legend-item-wrp"]}>
				<div className={styles["legend-item"]}>
					<div
						className={cn(
							styles["legend-item-sign"],
							tableMode ? styles["legend-item-sign-variant-table"] : styles["legend-item-sign-variant-group"],
							styles["legend-item-sign-repeat"],
						)}></div>
					<span className={styles["legend-item-txt"]}>Повторное категорирование</span>
				</div>
			</div>
			<div className={styles["legend-item-wrp"]}>
				<div className={styles["legend-item"]}>
					<div
						className={cn(
							styles["legend-item-sign"],
							tableMode ? styles["legend-item-sign-variant-table"] : styles["legend-item-sign-variant-group"],
							styles["legend-item-sign-waiting"],
						)}></div>
					<span className={styles["legend-item-txt"]}>Категорирование не завершено</span>
				</div>
			</div>
			{!batchesMode && (
				<>
					<div className={styles["legend-item-wrp"]}>
						<div className={styles["legend-item"]}>
							<div className={cn(styles["legend-item-sign"], styles["legend-item-sign-blue"])}>
								<Clock />
							</div>
							<span className={styles["legend-item-txt"]}>Осталось 3-10 дней</span>
						</div>
					</div>
					<div className={styles["legend-item-wrp"]}>
						<div className={styles["legend-item"]}>
							<div className={cn(styles["legend-item-sign"], styles["legend-item-sign-yellow"])}>
								<Clock />
							</div>
							<span className={styles["legend-item-txt"]}>Осталось менее 3 дней</span>
						</div>
					</div>
					<div className={styles["legend-item-wrp"]}>
						<div className={styles["legend-item"]}>
							<div className={cn(styles["legend-item-sign"], styles["legend-item-sign-red"])}>
								<Clock />
							</div>
							<span className={styles["legend-item-txt"]}>Просрочено</span>
						</div>
					</div>
				</>
			)}
		</div>
	);
};
